import { useMemo } from "react";
import FirmFlowTable from "../../../../components/mytasks/FirmFlowTable";
import { buildWorkloadDrilldownHref } from "../workloadDrilldownUtils";

const getMemberships = (employee) => {
    if (Array.isArray(employee?.teamMemberships)) {
        return employee.teamMemberships;
    }

    return Array.isArray(employee?.memberships) ? employee.memberships : [];
};

const getUniqueDepartmentNames = (memberships) => {
    const departmentNames = new Map();

    memberships.forEach((membership) => {
        const departmentName = membership?.departmentName?.trim();
        if (!departmentName) return;

        const key = departmentName.toLocaleLowerCase();
        if (!departmentNames.has(key)) {
            departmentNames.set(key, departmentName);
        }
    });

    return [...departmentNames.values()];
};

const EmployeeWorkloadTable = ({ data, appliedFilters }) => {
    const columns = useMemo(
        () => [
            {
                Header: "Employee",
                accessor: "employeeName",
                Cell: (props) => props.value,
            },
            {
                Header: "Department",
                id: "departments",
                accessor: (employee) =>
                    getUniqueDepartmentNames(getMemberships(employee)),
                Cell: (props) =>
                    props.value.length > 0 ? (
                        <div className="space-y-1">
                            {props.value.map((departmentName) => (
                                <div key={departmentName}>{departmentName}</div>
                            ))}
                        </div>
                    ) : (
                        "-"
                    ),
            },
            {
                Header: "Total Clients",
                accessor: "totalClients",
                Cell: (props) => {
                    return (
                        <a
                            href={buildWorkloadDrilldownHref(
                                appliedFilters,
                                {
                                    employeeId:
                                        props.row.original.employeeId,
                                },
                            )}
                            target="_blank"
                            rel="noreferrer"
                            className="text-blue-500 hover:underline"
                        >
                            {props.value}
                        </a>
                    );
                },
            },
        ],
        [appliedFilters],
    );
    const resetSignal = appliedFilters;

    return (
        <div>
            <FirmFlowTable
                columns={columns}
                data={data}
                resetPageSignal={resetSignal}
                resetSearchSignal={resetSignal}
            />
        </div>
    );
};

export default EmployeeWorkloadTable;
